import React, { useState } from 'react';
import { KeyIcon, ExternalLinkIcon } from 'lucide-react';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
import { setStoredApiKey, clearStoredApiKey } from '../../utils/apiKeyStorage';
interface ApiKeyPanelProps {
  apiKey: string;
  onApiKeyChange: (key: string) => void;
}
export function ApiKeyPanel({
  apiKey,
  onApiKeyChange
}: ApiKeyPanelProps) {
  const [draft, setDraft] = useState(apiKey);
  const [isOpen, setIsOpen] = useState(!apiKey);
  const handleSave = () => {
    const trimmed = draft.trim();
    setStoredApiKey(trimmed);
    onApiKeyChange(trimmed);
    if (trimmed) setIsOpen(false);
  };
  const handleClear = () => {
    clearStoredApiKey();
    setDraft('');
    onApiKeyChange('');
  };
  return <div className="border border-gray-100 rounded-2xl bg-gray-50/60" data-id="element-189" data-mp="1xo7eb8a3121k">
      <button type="button" onClick={() => setIsOpen(v => !v)} aria-expanded={isOpen} aria-controls="api-key-panel" className="w-full flex items-center justify-between gap-3 text-left p-5 min-h-[44px] rounded-2xl" data-id="element-190" data-mp="3dz2z4qtxcbjd">
        <div className="flex items-center gap-3 min-w-0" data-id="element-191" data-mp="29wlqhon8d70a">
          <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${apiKey ? 'bg-emerald-100' : 'bg-amber-100'}`} data-id="element-192" data-mp="29z7x9m2arihg">
            <KeyIcon className={`w-4 h-4 ${apiKey ? 'text-emerald-600' : 'text-amber-600'}`} data-id="element-193" data-mp="2jtzuupvvq5c8" />
          </div>
          <div className="min-w-0" data-id="element-194" data-mp="1m93uti0uhos1">
            <p className="text-sm font-bold text-apple-black" data-id="element-195" data-mp="1m5ptmd3x3lm6">Gemini API pripojenie</p>
            <p className="text-xs text-apple-gray truncate" data-id="element-196" data-mp="1r4j7w7r13gne">
              {apiKey ? 'Pripojené — reálne AI generovanie aktívne' : 'Nepripojené — beží demo režim'}
            </p>
          </div>
        </div>
        <span className="text-xs font-semibold text-apple-blue flex-shrink-0" data-id="element-197" data-mp="20y9tn4vrtcze">
          {isOpen ? 'Skryť' : 'Nastaviť'}
        </span>
      </button>

      {isOpen && <div id="api-key-panel" className="px-5 pb-5 pt-4 border-t border-gray-200 space-y-4" data-id="element-198" data-mp="18ekvjfg771dy">
          <Input id="gemini-api-key" label="Gemini API kľúč" type="password" placeholder="AIzaSy..." value={draft} onChange={e => setDraft(e.target.value)} helperText="Kľúč sa ukladá iba lokálne v tvojom prehliadači a nikdy neopúšťa toto zariadenie." data-id="element-199" data-mp="10dvh7mik93pz" />
          <div className="flex flex-wrap items-center gap-3" data-id="element-200" data-mp="hgc1y15ieov4">
            <Button size="small" onClick={handleSave} className="!bg-apple-blue hover:!bg-apple-blueHover !text-white !rounded-full !border-none" data-id="element-201" data-mp="hiojid7cux7n">
              Uložiť kľúč
            </Button>
            {apiKey && <Button size="small" variant="secondary" onClick={handleClear} className="!rounded-full" data-id="element-202" data-mp="mevtqi6sauve">
                Odpojiť
              </Button>}
            <a href="https://aistudio.google.com/apikey" target="_blank" rel="noopener noreferrer" className="text-xs font-semibold text-apple-blue flex items-center gap-1 hover:underline" data-id="element-203" data-mp="1xvdcjfhgkyzk">
              Získať bezplatný kľúč <ExternalLinkIcon className="w-3 h-3" data-id="element-204" data-mp="1wdoiosncou73" />
            </a>
          </div>
        </div>}
    </div>;
}